import type { Locale } from "@borealis/layout-express";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

const DealerLocaleContext = createContext<Locale>("en");

type DealerLocaleProviderProps = {
  locale: Locale;
  children: ReactNode;
};

export const DealerLocaleProvider = ({ locale, children }: DealerLocaleProviderProps) => (
  <DealerLocaleContext value={locale}>{children}</DealerLocaleContext>
);

export const useDealerLocale = () => {
  const context = useContext(DealerLocaleContext);
  if (context === "en") {
    throw new Error("useDealerLocale must be used within a DealerLocaleProvider");
  }
  return context;
};
